<template>
  <div class="welfare_page">
    <div class="loading_wrap" v-if="!page_show">
      <van-loading color="#d6151e" type="spinner" size="48" />
    </div>

    <div class="list_wrap" v-else>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="activity_list">
          <div
            class="activity_card"
            v-for="item in list"
            :key="item.activity_id"
          >
            <div class="activity_name">{{ item.activity_name }}</div>
            <img
              class="activity_image"
              :src="Util.getImgUrl(item.activity_image)"
              alt="活动图片"
            />
            <div class="activity_info">
              <div class="info_left">
                <span class="info_label">有效期：</span>
                <span class="info_value">{{ formatDate(item.valid_end) }}</span>
              </div>
              <div class="info_right">
                <span class="infoLabel">额度：</span>
                <span class="infoValue red">{{ item.point }}点</span>
              </div>
            </div>
            <van-button
              class="exchange_btn"
              round
              block
              color="#d6151e"
              @click="onExchange(item)"
            >
              立即兑换
            </van-button>
          </div>
        </div>
      </van-pull-refresh>

      <van-empty v-if="list.length === 0 && page_show" description="暂无活动" />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      page_show: false,
      list: [],
      title: "",
      refreshing: false,
    };
  },
  mounted() {
    document.title = "员工福利2026";
    this.loadData();
  },
  methods: {
    loadData() {
      let that = this;
      that.$api
        .ucenterWelfareActivities2026List({})
        .then((res) => {
          that.list = res.data.list || [];
          that.title = res.data.title || "";
          if (that.title) {
            document.title = that.title;
          }
          that.refreshing = false;
          that.page_show = true;
        })
        .catch(() => {
          that.refreshing = false;
          that.page_show = true;
        });
    },
    onRefresh() {
      this.loadData();
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      return dateStr.substring(0, 10);
    },
    onExchange(item) {
      if (item.activity_url) {
        window.location.href = item.activity_url;
      } else {
        Toast("兑换功能即将开放");
      }
      console.log("立即兑换", item.activity_id);
    },
  },
};
</script>

<style scoped src="./activities.css"></style>
